import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

const CustomStringAttributeNestedFilter = ({ onChange, data, initialState }) => {
  const [customStringAttributes, setCustomStringAttributes] = useState([]);

  useEffect(() => {
    // Initialize the active state based on initialState
    const updatedCustomStringAttributes = data.map((customStringAttribute) => {
      const initialCustomStringAttribute = initialState?.find(
        (initial) => initial.predefinedId === customStringAttribute.predefinedId,
      );
      return {
        ...customStringAttribute,
        active: initialCustomStringAttribute ? true : false,
      };
    });

    setCustomStringAttributes(updatedCustomStringAttributes);
  }, [data, onChange, initialState]);

  const handleCustomStringAttributeChange = (clickedCustomStringAttribute) => {
    // Update the active state of the clicked customStringAttribute
    const updatedCustomStringAttributes = customStringAttributes.map(
      (customStringAttribute) => {
        if (customStringAttribute.predefinedId === clickedCustomStringAttribute.predefinedId) {
          return {
            ...customStringAttribute,
            active: !customStringAttribute.active,
          };
        }
        return customStringAttribute;
      },
    );

    // Filter the active customStringAttributes
    const newArray = updatedCustomStringAttributes.filter(
      (customStringAttribute) => customStringAttribute.active,
    );

    // Update the state with the new active state and call the onChange callback
    setCustomStringAttributes(updatedCustomStringAttributes);

    onChange && onChange(newArray);
  };

  const handleSublistToggle = (e, clickedCustomStringAttribute) => {
    e.preventDefault();
    // Update the expanded state of the clicked customStringAttribute
    const updatedCustomStringAttributes = customStringAttributes.map(
      (customStringAttribute) => {
        if (customStringAttribute.predefinedId === clickedCustomStringAttribute.predefinedId) {
          return {
            ...customStringAttribute,
            expanded: !customStringAttribute.expanded,
          };
        }
        return customStringAttribute;
      },
    );

    // Update the state with the new expanded state
    setCustomStringAttributes(updatedCustomStringAttributes);
  };

  return (
    <>
      <div className="filters">
        <div className="filter">
          {Array.isArray(customStringAttributes) &&
            customStringAttributes
              .filter((x) => x.predefinedIdCount > 0 && !x.predefinedParentId)
              .map((customStringAttribute) => (
                <React.Fragment key={customStringAttribute.predefinedId}>
                  <div
                    className="element checkbox form-group"                    
                  >
                    <div className="field">
                      <div className="icheck-primary">
                        <input
                          type="checkbox"
                          id={`customStringAttributeCheckbox_${customStringAttribute.predefinedId}`}
                          aria-controls={customStringAttribute.predefinedId}
                          aria-checked={customStringAttribute.active || false}
                          checked={customStringAttribute.active || false}
                          onChange={() =>
                            handleCustomStringAttributeChange(customStringAttribute)
                          }
                        />
                        <label
                          htmlFor={`customStringAttributeCheckbox_${customStringAttribute.predefinedId}`}
                        >
                          {customStringAttribute.display ?? 
                            customStringAttribute.name}
                          <span className="count">
                            {customStringAttribute.predefinedIdCount === undefined
                              ? 0
                              : customStringAttribute.predefinedIdCount}
                          </span>
                        </label>
                      </div>
                    </div>   
                    { customStringAttributes
                        .filter((x) => x.predefinedIdCount > 0 && x.predefinedParentId === customStringAttribute.predefinedId && !x.active).length > 0 && 
                        !customStringAttribute.active &&
                        <a href="" className="toggle-sublist" onClick={(e) => handleSublistToggle(e, customStringAttribute) }>
                          <FontAwesomeIcon icon={ customStringAttribute.expanded  ? faMinus : faPlus} /></a>
                    }
                  </div>
                  <div className="sub-list">
                  {(customStringAttribute.expanded || customStringAttribute.active || customStringAttributes.filter((x) => x.predefinedParentId === customStringAttribute.predefinedId && x.active).length > 0) && 
                    customStringAttributes.filter((x) => x.predefinedIdCount > 0 && x.predefinedParentId === customStringAttribute.predefinedId)
                  .map((customStringAttribute2) => (                  
                    <div
                      className="element checkbox form-group"
                      key={customStringAttribute2.predefinedId}
                    >
                      <div className="field">
                        <div className="icheck-primary">
                          <input
                            type="checkbox"
                            id={`customStringAttributeCheckbox_${customStringAttribute2.predefinedId}`}
                            aria-controls={customStringAttribute2.predefinedId}
                            aria-checked={customStringAttribute2.active || false}
                            checked={customStringAttribute2.active || false}
                            onChange={() =>
                              handleCustomStringAttributeChange(customStringAttribute2)
                            }
                          />
                          <label
                            htmlFor={`customStringAttributeCheckbox_${customStringAttribute2.predefinedId}`}
                            title={customStringAttribute2.display ?? customStringAttribute2.name}
                          >
                            {customStringAttribute2.display ?? customStringAttribute2.name}
                            <span className="count">
                              {customStringAttribute2.predefinedIdCount === undefined
                                ? 0
                                : customStringAttribute2.predefinedIdCount}
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  ))}                    
                  </div>
                </React.Fragment>
              ))}
        </div>
      </div>
    </>
  );
};

export default CustomStringAttributeNestedFilter;